import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import PageMeta from "./PageMeta";

// The most recent treasurer's report.
const currentReport = {
  label: "Treasurer's Report – November 2026",
  date: "28 October 2026",
  file: "/assets/Treasurers_Report_28_10_2026.pdf",
};

// Add previous reports here once they are superseded by a newer one.
const archivedReports = [
  {
    label: "Treasurer's Report – October 2026",
    date: "3 October 2026",
    file: "/assets/Treasurers_Report_3_10_2026.pdf",
  },
  {
    label: "Treasurer's Report – September 2026",
    date: "8 September 2026",
    file: "/assets/Treasurers_report_8_9_2026.pdf",
  },
  {
    label: "Treasurer's Report – August 2026",
    date: "3 August 2026",
    file: "/assets/Treasurers_report_3_8_2026.pdf",
  },
  {
    label: "Treasurer's Report – July 2026",
    date: "6 July 2026",
    file: "/assets/Treasurers_report_6_7_2026.pdf",
  },
  {
    label: "Treasurer's Report – June 2026",
    date: "2 June 2026",
    file: "/assets/Treasurers_Report_2_06_2026.pdf",
  },
  {
    label: "Treasurer's Report – May 2026",
    date: "9 May 2026",
    file: "/assets/Treasurers_Report_9_05_2026.pdf",
  },
  {
    label: "Treasurer's Report – April 2026",
    date: "18 April 2026",
    file: "/assets/Treasurers_Report_18_4_26.pdf",
  },
];

function ReportCard({ item, colorClass, borderHover, bgHover, badgeBorder, badgeBg, badgeText }) {
  return (
    <a
      href={item.file}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center gap-5 rounded-2xl border border-white/10 bg-white/5 p-5 transition ${borderHover} ${bgHover}`}
    >
      <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${colorClass}`}>
        <FileText className="h-6 w-6" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-white">{item.label}</p>
        <p className="mt-0.5 text-xs text-slate-400">{item.date}</p>
      </div>
      <span className={`shrink-0 rounded-lg border ${badgeBorder} ${badgeBg} px-3 py-1 text-xs font-medium ${badgeText}`}>
        Open PDF
      </span>
    </a>
  );
}

export default function TreasurerPage() {
  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta title="Treasurer's Reports | Redruth Sea Angling Association" noindex />
      <div className="mx-auto max-w-4xl px-6 py-16 sm:px-8 lg:px-12">

        <div className="flex flex-wrap gap-3">
          <Link to="/" className="standalone-only inline-flex items-center gap-2 rounded-lg border border-cyan-300/40 bg-cyan-400/10 px-4 py-2 text-sm text-cyan-200 transition hover:bg-cyan-400/20">
            ← Back
          </Link>
          <Link to="/members" className="inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/5 px-4 py-2 text-sm text-slate-300 transition hover:bg-white/10">
            Members' Documents
          </Link>
        </div>

        <div className="mt-8">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">Redruth Sea Angling Association</p>
          <h1 className="heading-glow mt-3 text-4xl font-bold tracking-tight text-white sm:text-5xl">Treasurer's Reports</h1>
        </div>

        {/* Current Report */}
        <div className="mt-10">
          <h2 className="text-xl font-semibold text-emerald-300 mb-4">Current Treasurer's Report</h2>
          {currentReport ? (
            <ReportCard
              item={currentReport}
              colorClass="bg-emerald-400/10 text-emerald-300"
              borderHover="hover:border-emerald-300/30"
              bgHover="hover:bg-emerald-400/5"
              badgeBorder="border-emerald-300/20"
              badgeBg="bg-emerald-400/10"
              badgeText="text-emerald-300"
            />
          ) : (
            <p className="text-slate-400">No current report has been published yet.</p>
          )}
        </div>

        {/* Archived Reports */}
        <div className="mt-12">
          <h2 className="text-xl font-semibold text-slate-300 mb-4">Archived Treasurer's Reports</h2>
          {archivedReports.length === 0 ? (
            <p className="text-slate-400">No archived reports yet.</p>
          ) : (
            <div className="space-y-4">
              {archivedReports.map((item) => (
                <ReportCard
                  key={item.file}
                  item={item}
                  colorClass="bg-slate-400/10 text-slate-300"
                  borderHover="hover:border-slate-300/30"
                  bgHover="hover:bg-slate-400/5"
                  badgeBorder="border-slate-300/20"
                  badgeBg="bg-slate-400/10"
                  badgeText="text-slate-300"
                />
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  );
}
